import { render, staticRenderFns } from "./quickActionButton.vue?vue&type=template&id=53f57223&"
import script from "./quickActionButton.vue?vue&type=script&lang=js&"
export * from "./quickActionButton.vue?vue&type=script&lang=js&"
import style0 from "./quickActionButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports